exports = module.exports = require("./../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".wave{width:50px;height:27px}.wave>div{background-color:#333;height:100%;width:6px;display:inline-block;-webkit-animation:stretchdelay 1.2s infinite ease-in-out;animation:stretchdelay 1.2s infinite ease-in-out}.wave .rect2{-webkit-animation-delay:-1.1s;animation-delay:-1.1s}.wave .rect3{-webkit-animation-delay:-1s;animation-delay:-1s}.wave .rect4{-webkit-animation-delay:-.9s;animation-delay:-.9s}.wave .rect5{-webkit-animation-delay:-.8s;animation-delay:-.8s}@-webkit-keyframes stretchdelay{0%,40%,to{-webkit-transform:scaleY(.4)}20%{-webkit-transform:scaleY(1)}}@keyframes stretchdelay{0%,40%,to{transform:scaleY(.4);-webkit-transform:scaleY(.4)}20%{transform:scaleY(1);-webkit-transform:scaleY(1)}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./~/react-spinkit/css/wave.css
 ** module id = 210
 ** module chunks = 0
 **/